

  $(document).ready(function () {
    $(".slider_testimonial_sec1").slick({
      infinite: false,
      arrow:true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: $(".slide_controls_2 .slide-prev"),
      nextArrow: $(".slide_controls_2 .slide-next"),
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
     ]
    });

    $(".slider_testimonial_sec").slick({
      infinite: false,
      arrow:true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      infinite: true,
      prevArrow: $(".flex_arrow1 .left_arows"),
      nextArrow: $(".flex_arrow1 .right_arows"),
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
   ]
    });
var videotvpopup = document.getElementById('pausepopup');

    
    
   $('body').on('click', '.nav_img_s .ic img', function(){
     $('.videoClips').addClass('append_vedio');
      $("video").prop('muted', false);
     videotvpopup.play();
     $(this).parent().find('.videoClips').removeClass('append_vedio');
   });

    $('.videoClips').click(function(){
                $("video").prop('muted', false);
      $('.videoClips').addClass('append_vedio');
    });

  
    setTimeout(function(){
      $('.img_right').addClass('effect');
    }, 3000);

      $('.videoClips').click(function(){
  videotvpopup.pause();
 
});

var video = document.getElementById('section-video');
var playButton = $('#play-button');


playButton.click(function() {
  videotv.pause();
  tvButton.show();
    video.play();
    playButton.hide(); // Hide the play button when video starts playing
});


    
$('.pauseVideo').click(function(){
  video.pause();
  playButton.show();
});


    
var videotv = document.getElementById('tv-video');
var tvButton = $('#tv-button');
    
    tvButton.click(function () {
      if (videotv.paused || video.ended) {
        video.pause();
        playButton.show();
        videotv.play();
        $('.tv-video-container').css('visibility', 'visible');
        tvButton.hide();
      } 
    });

    $('#tv-video').click(function(){
  videotv.pause();
  tvButton.show();
});
    
  });
 
   



